module.exports = __webpack_public_path__ + "static/media/UniNeueBlack.c517ec49.ttf";